export const PRIVATE_KEY = `MIIJQgIBADANBgkqhkiG9w0BAQEFAASCCSwwggkoAgEAAoICAQDTi3r2v8/PgE6N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`
// 可同时暴露其他配置（如加密相关参数）
export const ENCRYPT_CONFIG = {
  padding: 'RSA_PKCS8_PADDING', // 填充方式
  charset: 'utf8' // 编码格式
};